import "./PoushVideoStyles.css";
import React from "react";
import YouTube from "react-youtube";
import ShikhaaLogo from "../../../Assets/Cover/Shikhaa_Logo.png";
// install: npm install react-youtube

const PoushVideo = () => {
  const videoIds = [
    { id: "2mN8Z8M3REw", startTime: 0 },
    { id: "MZDjzGjDyw4", startTime: 0 },
    { id: "2bhdwomYhSM", startTime: 0 },
    { id: "CuvPEBje4Aw", startTime: 0 },
    { id: "SiYhw1QpY58", startTime: 0 },
    { id: "tdSWir1sQ4I", startTime: 0 },
    { id: "0zGpqOP4Fmw", startTime: 0 },
    { id: "GOzsfOenX48", startTime: 0 },
    { id: "Er2i9tWbZuI", startTime: 0 },
    { id: "taT9RaOoRNg", startTime: 0 },
    { id: "WOmqWylj95s", startTime: 0 },
    { id: "5jmO2LnEVLI", startTime: 0 },
    { id: "_PdwoGFi-7M", startTime: 0 },
    { id: "GNfQKXgrytc", startTime: 0 },
  ];

  const handleVideoClick = (videoId) => {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, "_blank");
  };

  return (
    <div className="poush-video-container">
      <div className="poush-video-logo">
        <img src={ShikhaaLogo} alt="Shikhaa The Light Logo" />
      </div>

      <h1>SHIKHAA – THE LIGHT VIDEOS</h1>

      <p className="poush-video-intro">
        Explore cultural moments, community programs, and celebrations organized
        by Shikhaa – The Light as we continue to preserve Bangladeshi culture,
        heritage, and identity in South Florida.
      </p>

      <div className="video-container">
        {videoIds.map((video, index) => (
          <div key={index} className="video-card">
            <div className="video-embed">
              <YouTube
                videoId={video.id}
                opts={{
                  width: "100%",
                  height: "100%",
                  playerVars: {
                    autoplay: 0,
                    start: video.startTime,
                  },
                }}
              />
            </div>

            <button
              className="youtube-link"
              onClick={() => handleVideoClick(video.id)}
            >
              Watch on YouTube
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PoushVideo;
